import { format, parse } from 'date-fns'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'GtrDateTimePicker',
  inheritAttrs: false
})
export default class GtrDatetimePicker extends Vue {
  get isMobile (): boolean {
    return this.$vuetify.breakpoint.xsOnly
  }

  get nativeValue (): string {
    const val = (this.$attrs as any).value
    if (!val) return ''
    try {
      const d = val instanceof Date ? val : new Date(val)
      if (isNaN(d.getTime())) return ''
      return format(d, "yyyy-MM-dd'T'HH:mm")
    } catch {
      return ''
    }
  }

  onNativeInput (val: string) {
    if (!val) {
      this.$emit('input', null)
      return
    }
    const d = parse(val, "yyyy-MM-dd'T'HH:mm", new Date())
    this.$emit('input', isNaN(d.getTime()) ? null : d)
  }
}
